import { render, staticRenderFns } from "./EditVirtualVisit.vue?vue&type=template&id=686acc64"
import script from "./EditVirtualVisit.vue?vue&type=script&lang=js"
export * from "./EditVirtualVisit.vue?vue&type=script&lang=js"
import style0 from "./EditVirtualVisit.vue?vue&type=style&index=0&id=686acc64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports